import { FaBars, FaBell } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import "./Layout.css"; // create this
import { Link } from "react-router-dom";
import axios from "axios";
import "./Topbar.css"; // create this
export default function Topbar({ toggleSidebar }) {

  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
const API = "https://data.shreemwell.in/api/connection-requests";
const [notifications, setNotifications] = useState([]);
const [showNotifications, setShowNotifications] = useState(false);
const [notificationCount, setNotificationCount] = useState(0);
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUser(userData);
  }, []);

  // close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.href = "/";
  };
useEffect(() => {
  fetchNotifications();

  // refresh every 10 seconds
  const interval = setInterval(fetchNotifications, 10000);

  return () => clearInterval(interval);
}, []);

const fetchNotifications = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!token) return;

    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentUserId = payload.id || payload._id;

    const res = await axios.get(`${API}/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const requests = res.data.data || [];

  const pending = requests.filter(
  (item) =>
    String(item.receiver?._id) === String(currentUserId) &&
    item.status === "Pending"
);

setNotificationCount(pending.length);
setNotifications(pending);

    setNotificationCount(pending.length);
  } catch (err) {
    console.log(err);
  }
};
  return (
    <div className="topbar">

      <div className="left">
        <FaBars className="menu-icon mobile-toggle" onClick={toggleSidebar} />
      </div>

      <div className="right">
<div className="notification-wrapper">

  <div
    className="notification-box"
    onClick={() => setShowNotifications(!showNotifications)}
  >
    <FaBell className="icon" />

    {notificationCount > 0 && (
      <span className="notification-badge">
        {notificationCount}
      </span>
    )}
  </div>

  {showNotifications && (
    <div className="notification-dropdown">

      <h4>Notifications</h4>

      {notifications.length === 0 ? (
        <p className="empty">No new requests</p>
      ) : (
        notifications.slice(0, 5).map((item) => (
          <div className="notification-item" key={item._id}>

            <div className="notification-avatar">
              {item.sender?.name?.charAt(0)}
            </div>

            <div className="notification-content">
              <strong>{item.sender?.name}</strong>

              <p>sent you a connection request.</p>

              <small>
                {item.sender?.email}
              </small>
            </div>

          </div>
        ))
      )}

      {notifications.length > 5 && (
        <Link
          to="/MutualManagement"
          className="view-all"
          onClick={() => setShowNotifications(false)}
        >
          View All Requests
        </Link>
      )}

    </div>
  )}

</div>
        {/* PROFILE */}
        <div className="profile-container" ref={dropdownRef}>
          <div
            className="profile-circle"
            onClick={() => setOpen(!open)}
          >
            {user?.name?.charAt(0) || "U"}
          </div>

          {/* DROPDOWN */}
          {open && (
            <div className="dropdown">
              <div className="dropdown-header">
                <span
                  className="close-icon"
                  onClick={() => setOpen(false)}
                >
                  ×
                </span>

                <div className="avatar">
                  {user?.name?.charAt(0) || "U"}
                </div>

                <h4>{user?.name || "User"}</h4>
                <p>{user?.email || "email@gmail.com"}</p>
              </div>

              <div className="dropdown-actions">
                <Link to="/My-Account">
                  <button className="account-btn">My Account</button>
                </Link>
                <button className="logout-btn" onClick={handleLogout}>
                  Sign out
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}